export default function IconFileRotate({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0.72 0.72 16.57 16.57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M13.1172 1.33789L11.1631 2.40843L12.0881 4.4258"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.205 5.96886C15.977 5.34195 15.6159 4.77191 15.1464 4.29803C14.6578 3.81937 14.0714 3.45216 13.4275 3.22162C12.7836 2.99108 12.0974 2.90268 11.416 2.96249"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.9873 16.7197L6.94071 15.6492L6.01637 13.6318"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.90039 12.0879C2.12705 12.7145 2.48675 13.2845 2.95477 13.7587C3.44354 14.239 4.03027 14.608 4.67482 14.8405C5.31938 15.0731 6.00655 15.1637 6.68936 15.1062"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.49784 1.28027H7.26783C7.26783 1.28027 7.97075 1.28027 7.97075 1.98319V8.81132C7.97075 8.81132 7.97075 9.51424 7.26783 9.51424H2.49784C2.49784 9.51424 1.79492 9.51424 1.79492 8.81132V1.98319C1.79492 1.98319 1.79492 1.28027 2.49784 1.28027Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7322 8.4541H15.5022C15.5022 8.4541 16.2051 8.4541 16.2051 9.15702V16.0168C16.2051 16.0168 16.2051 16.7197 15.5022 16.7197H10.7322C10.7322 16.7197 10.0293 16.7197 10.0293 16.0168V9.15702C10.0293 9.15702 10.0293 8.4541 10.7322 8.4541Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
